.bookMeeting > h1 {
	width: 100%;
	text-align: center;
	font-size: 6rem;
	padding-right: 0.5rem;
}
.personCard {
	max-width: fit-content;
}
